import { render, staticRenderFns } from "./addNemiPayBizUser.vue?vue&type=template&id=53b4458f&"
import script from "./addNemiPayBizUser.vue?vue&type=script&lang=ts&"
export * from "./addNemiPayBizUser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports